export const CTAButton = ({ marginX }) => (
  <button
    className={`px-6 py-4 bg-[#66deb1] rounded-full border-solid border-4 border-white text-[1.3rem] font-interextrabold leading-none text-[#003380] block mx-${marginX} xl:text-2xl xl:px-8 xl:py-5`}
    type="button"
  >
    Buy Tickets
  </button>
);
